/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TotalDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TotalDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/TotalDiscount"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let setupPayorDiscountsValueData = fromData.useDataValue({ viewPath,
context: 'setup',
path: 'payor_discounts',
})
let paymentPlanPaymentPlanDiscountValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'payment_plan_discount',
})
let aggregateData = fromHelpers.getTotalDiscount(setupPayorDiscountsValueData, paymentPlanPaymentPlanDiscountValueData)
  return (<React.Fragment
>
<div
  data-testid="TotalDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Total payor discount"
 weight="medium"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="setup.payor_discounts"
 data="payment_plan.payment_plan_discount"
 aggregate="helpers.js getTotalDiscount"
 text={aggregateData}
 weight="medium"
/>
</div>
{children}
</React.Fragment>)
}